const activeTimers = {};

const START_TIMER = 'TIMER.START_TIMER';
const STOP_TIMER = 'TIMER.STOP_TIMER';

export const startTimer = (name, interval, repeatAction, description) => ({
    type: START_TIMER,
    name,
    interval,
    repeatAction,
    description
});

export const stopTimer = name => ({
    type: STOP_TIMER,
    name
});

export const timerMiddleware = ({ dispatch }) => next => async action => {
    switch (action.type) {
        case START_TIMER: {
            activeTimers[action.name] = setInterval(() => {
                dispatch(action.repeatAction);
            }, action.interval);
            dispatch(action.repeatAction);
            break;
        }
        case STOP_TIMER: {
            clearInterval(activeTimers[action.name]);
            delete activeTimers[action.name];
            break;
        }
        default: {
            return next(action);
        }
    }

    return next(action);
};
